"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const GridIcon = _ref => {
  let {
    fill
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.58335 0.749756C1.0769 0.749756 0.665771 1.16042 0.665771 1.66688V6.24976C0.665771 6.75621 1.0769 7.16688 1.58335 7.16688H6.16669C6.67269 7.16688 7.08335 6.75621 7.08335 6.24976V1.66688C7.08335 1.16042 6.67269 0.749756 6.16669 0.749756H1.58335ZM1.58335 9.00021C1.0769 9.00021 0.665771 9.40996 0.665771 9.91642V14.5002C0.665771 15.0058 1.0769 15.4164 1.58335 15.4164H6.16669C6.67269 15.4164 7.08335 15.0058 7.08335 14.5002V9.91642C7.08335 9.40996 6.67269 9.00021 6.16669 9.00021H1.58335ZM9.83335 0.749756C9.32735 0.749756 8.91668 1.16042 8.91668 1.66688V6.24976C8.91668 6.75621 9.32735 7.16688 9.83335 7.16688H14.4167C14.9231 7.16688 15.3333 6.75621 15.3333 6.24976V1.66688C15.3333 1.16042 14.9231 0.749756 14.4167 0.749756H9.83335ZM9.83335 9.00021C9.32735 9.00021 8.91668 9.40996 8.91668 9.91642V14.5002C8.91668 15.0058 9.32735 15.4164 9.83335 15.4164H14.4167C14.9231 15.4164 15.3333 15.0058 15.3333 14.5002V9.91642C15.3333 9.40996 14.9231 9.00021 14.4167 9.00021H9.83335Z",
    fill: fill
  }));
};

GridIcon.propTypes = {
  fill: _propTypes.default.string.isRequired
};
var _default = GridIcon;
exports.default = _default;